/* 1119 - GTA POD product page components.
   Plain custom elements: they initialise on connectedCallback, so they work on
   first paint, on shopify:section:load, and inside the theme editor. Listeners
   live on the element itself, so shopify:section:unload cleans them up for free.
   Only the document-level editor listeners are added once and are idempotent. */
(function () {
  'use strict';

  var DESIGN = window.Shopify && window.Shopify.designMode;

  /* ---------- accordion ---------- */
  if (!customElements.get('gtap-accordion')) {
    customElements.define(
      'gtap-accordion',
      class extends HTMLElement {
        connectedCallback() {
          this.single = this.getAttribute('data-single') !== 'false';
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKey);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKey);
        }
        get buttons() {
          return Array.prototype.slice.call(this.querySelectorAll('[data-gtap-acc-btn]'));
        }
        onClick = (e) => {
          var btn = e.target.closest('[data-gtap-acc-btn]');
          if (!btn || !this.contains(btn)) return;
          this.toggle(btn, btn.getAttribute('aria-expanded') !== 'true');
        };
        onKey = (e) => {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          var btn = e.target.closest('[data-gtap-acc-btn]');
          if (!btn) return;
          var all = this.buttons;
          var i = all.indexOf(btn);
          if (i < 0) return;
          e.preventDefault();
          var next = e.key === 'ArrowDown' ? (i + 1) % all.length : (i - 1 + all.length) % all.length;
          all[next].focus();
        };
        toggle(btn, open) {
          if (open && this.single) {
            this.buttons.forEach((b) => {
              if (b !== btn) this.setRow(b, false);
            });
          }
          this.setRow(btn, open);
        }
        setRow(btn, open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          var icon = btn.querySelector('[data-gtap-acc-icon]');
          if (icon) icon.textContent = open ? '−' : '+';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.hidden = !open;
        }
        openRowFor(node) {
          var row = node.closest('[data-gtap-acc-row]');
          if (!row) return;
          var btn = row.querySelector('[data-gtap-acc-btn]');
          if (btn) this.toggle(btn, true);
        }
      }
    );
  }

  /* ---------- size guide dialog ---------- */
  if (!customElements.get('gtap-size-guide')) {
    customElements.define(
      'gtap-size-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.close();
        }
        get dialog() {
          return this.querySelector('dialog');
        }
        onClick = (e) => {
          if (e.target.closest('[data-gtap-sg-open]')) {
            e.preventDefault();
            this.open();
          } else if (e.target.closest('[data-gtap-sg-close]')) {
            e.preventDefault();
            this.close();
          } else if (e.target === this.dialog) {
            this.close();
          }
        };
        open() {
          var d = this.dialog;
          if (!d) return;
          this.opener = document.activeElement;
          if (typeof d.showModal === 'function' && !d.open) d.showModal();
          else d.setAttribute('open', '');
          var first = d.querySelector('[data-gtap-sg-close]');
          if (first) first.focus();
        }
        close() {
          var d = this.dialog;
          if (!d || !d.open) return;
          if (typeof d.close === 'function') d.close();
          else d.removeAttribute('open');
          if (this.opener && this.opener.focus) this.opener.focus();
        }
      }
    );
  }

  /* ---------- horizontal rail ---------- */
  if (!customElements.get('gtap-rail')) {
    customElements.define(
      'gtap-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gtap-rail]');
          this.prevBtn = this.querySelector('[data-gtap-rail-prev]');
          this.nextBtn = this.querySelector('[data-gtap-rail-next]');
          if (!this.track) return;
          this.addEventListener('click', this.onClick);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.sync();
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.raf) cancelAnimationFrame(this.raf);
        }
        step() {
          var first = this.track.firstElementChild;
          var w = first ? first.getBoundingClientRect().width + 10 : 280;
          return Math.max(w, Math.round(this.track.clientWidth * 0.8));
        }
        onClick = (e) => {
          if (e.target.closest('[data-gtap-rail-prev]')) this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
          else if (e.target.closest('[data-gtap-rail-next]')) this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
        };
        onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.sync();
          });
        };
        sync() {
          if (!this.track) return;
          var max = this.track.scrollWidth - this.track.clientWidth - 1;
          if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
          if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max;
        }
        reveal(node) {
          if (!this.track || !node) return;
          var item = node.closest('[data-gtap-rail] > *');
          if (item) this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }
      }
    );
  }

  /* ---------- theme editor plumbing ---------- */
  if (DESIGN && !window.__gtapEditorBound) {
    window.__gtapEditorBound = true;

    var bringIntoView = function (target) {
      if (!target || !target.closest) return;
      var acc = target.closest('gtap-accordion');
      if (acc && acc.openRowFor) acc.openRowFor(target);
      var rail = target.closest('gtap-rail');
      if (rail && rail.reveal) rail.reveal(target);
      if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    document.addEventListener('shopify:block:select', function (e) {
      bringIntoView(e.target);
      var sg = e.target.closest && e.target.closest('gtap-size-guide');
      if (sg && sg.open) sg.open();
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var sg = e.target.closest && e.target.closest('gtap-size-guide');
      if (sg && sg.close) sg.close();
    });

    document.addEventListener('shopify:section:select', function (e) {
      bringIntoView(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var dialogs = e.target.querySelectorAll ? e.target.querySelectorAll('dialog[open]') : [];
      Array.prototype.forEach.call(dialogs, function (d) {
        if (d.close) d.close();
      });
    });
  }
})();
